class paymentInstruments {
    removePayment () {
        $('.remove-card .delete-confirmation-btn').on('click', e => {
            e.preventDefault();
            const UUID = $(e.currentTarget).data('id');
            const url = $(e.currentTarget).data('url') + '?UUID=' + UUID;

            $('#uuid-' + UUID).addClass('loading');
            $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                success: data => {
                    $('#uuid-' + UUID).remove();
                },
                error: err => {
                    $('#uuid-' + UUID).removeClass('loading');
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    }
                }
            });
        });
    }
}

const PaymentInstruments = new paymentInstruments();
export default PaymentInstruments;



// WEBPACK FOOTER //
// ./assets/scripts/myaccount/paymentinstruments.js